module.exports = __webpack_public_path__ + "img/scoremaster_futurescore.3fda25ea.jpg";